export default __webpack_public_path__ + "static/media/33-min.dc47e59e.jpg";